// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_ListaPorCategoriaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /so/additional_services/lista_por_categoria/{categoryId}
 * (controllers/so/additional_services.php::lista_por_categoria).
 *
 * Um campo, OPCIONAL: a franquia cujo preco local deve valer.
 *
 * Sem `franchise_id` a listagem responde os defaults globais — exatamente o
 * que ela sempre respondeu, entao nenhum chamador existente muda. Com ele, os
 * precos/prazos por franquia (so_additional_service_prices, migracao E3)
 * SOBREPOEM os defaults e os adicionais que a franquia desligou saem da
 * lista. O modal de adicionar item passa a franquia da OS.
 */
import { registerContract } from './validate'

export interface AdditionalServices_ListaPorCategoriaInput {
franchise_id?: string
}

registerContract('AdditionalServices_ListaPorCategoriaInput', {
  franchise_id: { type: 'string',  required: false },
})
